export default {
  name: "v-rounded-button",
  props: {
    title: String,
    link: String
  },
  computed: {
    primaryColor: function primaryColor() {
      return getComputedStyle(document.documentElement).getPropertyValue('--primary-color');
    }
  },
  methods: {}
};